// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const AggregateGroupWrapper = styled.table`
  font-size: .9rem;

  td,
  th {
    padding: .25em .5em;
    text-align: center;
  }

  > thead > tr {
    > td {
      font-weight: bold;
    }

    > th {
      font-weight: normal;
      text-decoration: underline;
    }
  }

`
